
import { Component, Prop } from '@modules/vue-property-decorator';
import Vue from 'vue';

export interface WeekDays {
    mon: boolean;
    tue: boolean;
    wen: boolean;
    thu: boolean;
    fri: boolean;
    sat: boolean;
    sun: boolean;
}

@Component({})
export default class CampDays extends Vue {
    @Prop({ required: true }) days!: WeekDays;
    private daysText = [
        this.$t('Monday').toString(),
        this.$t('Tuesday').toString(),
        this.$t('Wednesday').toString(),
        this.$t('Thursday').toString(),
        this.$t('Friday').toString(),
        this.$t('Saturday').toString(),
        this.$t('Sunday').toString(),
    ];

    private isSelected(dow: number): boolean {
        switch (dow % 7) {
            case 0:
                return this.days.mon;
            case 1:
                return this.days.tue;
            case 2:
                return this.days.wen;
            case 3:
                return this.days.thu;
            case 4:
                return this.days.fri;
            case 5:
                return this.days.sat;
            case 6:
                return this.days.sun;
            default:
                return false;
        }
    }
}
